import { Icon } from '@repo/ui';
import { ButtonColors, ButtonSizes, DesignButton, Modal, Typography } from 'components';

import styles from './ExitFormsWarningModal.module.css';

export type ExitFormsWarningModalVariant = 'landing' | 'survey';

const COPY: Record<
  ExitFormsWarningModalVariant,
  {
    title: string;
    description: string;
    cancelLabel: string;
    confirmLabel: string;
  }
> = {
  landing: {
    title: 'Complete your health forms within the next 2 weeks',
    description: 'We need your health forms to create your report.',
    cancelLabel: 'Complete now',
    confirmLabel: "I'll do it later",
  },
  survey: {
    title: 'Exiting now will lose your progress in this form.',
    description: 'Are you sure you want to exit out of this form?',
    cancelLabel: 'Cancel',
    confirmLabel: 'Exit form',
  },
};

export type ExitFormsWarningModalProps = {
  isOpen: boolean;
  variant: ExitFormsWarningModalVariant;
  onCancel: () => void;
  onConfirm: () => void;
};

export const ExitFormsWarningModal = ({
  isOpen,
  variant,
  onCancel,
  onConfirm,
}: ExitFormsWarningModalProps) => {
  const copy = COPY[variant];

  return (
    <Modal
      controlledIsOpen={isOpen}
      onClose={onCancel}
      showHeader={false}
      dialogClassName={styles.dialog}
    >
      <div className={styles.container}>
        <Icon name='alertCircleFilled' size={64} color='orange-300' />
        <div className={styles.textsContainer}>
          <Typography variant='heading-l' className='text-center'>
            {copy.title}
          </Typography>
          <Typography variant='body-s' className='grey-text text-center'>
            {copy.description}
          </Typography>
        </div>
        <div className={styles.buttonsContainer}>
          <DesignButton
            label={copy.cancelLabel}
            variant='outline'
            color={ButtonColors.PURPLE}
            size={ButtonSizes.M}
            width='full'
            onClick={onCancel}
          />
          <DesignButton
            label={copy.confirmLabel}
            color={ButtonColors.PURPLE}
            size={ButtonSizes.M}
            width='full'
            onClick={onConfirm}
          />
        </div>
      </div>
    </Modal>
  );
};

export default ExitFormsWarningModal;
